// import { CodeSandboxCircleFilled, SoundTwoTone } from "@ant-design/icons";
// import { clippingParents } from "@popperjs/core";
// import { useEffect, useState } from "react"
// import Topdesk from "../../API/MICROSERVICES/topdesk/topdesk";




// @ts-ignore
export default function Pruebas(props: any) {



  // async function SingleSignOn_AD() {

  //   let tenantID = "";

  //   const clientId = 'your_client_id';
  //   const authorityUrl = `https://login.microsoftonline.com/${tenantID}/oauth2/v2.0/authorize`;


  //   const samlResponse = await fetch(`${authorityUrl}?response_type=code&client_id=${clientId}&scope=https://graph.microsoft.com/.default`);


  //   let respuestaSAML: any = samlResponse.json().then((data) => {
  //     const code = data.code;
  //     return code;
  //   });


  //   const code = respuestaSAML.code;
  //   const idTokenUrl = `https://login.microsoftonline.com/${tenantID}/oauth2/v2.0/token?grant_type=urn:okta:sso:token&client_id=${clientId}&response_mode=pkce&code=${code}`;

  //   let usuario = await fetch(idTokenUrl)
  //     .then((res) => res.json())
  //     .then((data) => {
  //       const user = data.user;
  //       console.log(user);
  //     });


  //   const userIdentityResponseUrl = `https://login.microsoftonline.com/${tenantID}/oauth2/v2.0/audience`;
  //   fetch(`${idTokenUrl}&identity=urn:okta:sso:response_type=code&response_mode=pkce`)
  //     .then((res) => res.json())
  //     .then((data) => {
  //       const user = data.user;
  //       console.log(user);
  //     });



  // }

  // const [datos, setDatos] = useState(null);


  // async function coookie() {

  //   const cookies = document.cookie.split(';'); // Separa las cookies por punto y coma

  //   let valorCookie: string | null = null;

  //   for (let i = 0; i < cookies.length; i++) {
  //     let cookie = cookies[i].trim();
  //     // Busca la cookie con el nombre específico
  //     if (cookie.startsWith('nombreDeLaCookie=')) {
  //       valorCookie = cookie.substring('nombreDeLaCookie='.length, cookie.length);
  //       break;
  //     }
  //   }

  //   console.log("valorCookie ", valorCookie);

  //   await getAllCookies();


  //   var x = document.cookie;
  //   window.alert(x);

  // }


  // const getAllCookies = () => {
  //   const allCookies = document.cookie;
  //   // Dividir la cadena para obtener un arreglo de cookies individuales
  //   const cookieArray = allCookies.split(';');

  //   const cookieList: any[] = [];
  //   cookieArray.forEach(cookie => {
  //     // Dividir cada cookie en su clave y valor
  //     const [name, ...value] = cookie.split('=');
  //     cookieList.push({
  //       name: name.trim(), // Eliminar espacios en blanco al inicio
  //       value: value.join('=') // Unir el valor de nuevo si contiene '='
  //     });
  //   });

  //   console.log(cookieList);
  //   return cookieList;
  // };


  // useEffect(() => {
  //   coookie();
  // }, []);



  return (
    <>
      <h1>Prueba</h1>
    </>
  )

}

